import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { Divider, Button } from "@material-ui/core";
import { connect } from "react-redux";
import Axios from "axios";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import jwtDecode from "jwt-decode";

import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";

import PaypalLogo from "../../../Assets/Images//paypal.png";
import { url } from "../../../config/config";
import Header from "../../../Component/NavBar/User/Header/Header";
import Footer from "../../../Component/NavBar/User/Footer/Footer";
import CartTable from "./CartTable";
import CartDialogBox from "./CartDialogBox";
import CustomLoader from "../../../Component/CustomLoader/CustomLoader";
import CustomerKhaltiPay from "../../../Component/KhaltiPay/CustomerKhaltiPay";
import CustomEmptyMessage from "../../../Component/CustomEmptyMessage/CustomEmptyMessage";
import { useStyles } from "./Cart.css";
import MobileCart from "./MobileCart/MobileCart";
import FormLoader from "../../../Component/FormLoader/FormLoader";

class Cart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      column: [
        {
          name: "S.N.",
        },
        {
          name: "Cover Image",
        },
        {
          name: "Title",
        },
        {
          name: "Genre",
        },
        {
          name: "Quantity",
        },
        {
          name: "Price",
        },
        {
          name: "Actions",
        },
      ],
      cart: [],
      success: "",
      isEmpty: false,
      totalPrice: 0,
      changedCurrency: 0,
      cartCount: 0,
      notificationOpen: false,
      emailVerified: false,
      dialogOpen: false,
      payType: "",
      orderId: this.generateId(16),
      loading: false,
    };
  }

  componentDidMount() {
    this.getData();
    this.getCartCount();
    this.decodeToken(this.props.userToken);
  }

  decodeToken = async (userToken) => {
    try {
      let userData = await jwtDecode(userToken);
      this.setState({
        emailVerified: userData.isVerified,
      });
    } catch (error) {}
  };

  getData = async () => {
    const response = await Axios.get(`${url}/api/carts/cartDetails`, {
      headers: {
        "x-auth-token": this.props.userToken,
      },
    });
    if (response.data.cart.length !== 0) {
      let tempPrice = 0;
      response.data.cart.map((cart) => (tempPrice += cart.id.price));
      this.setState({
        totalPrice: tempPrice,
      });
    }
    if (response.data.cart.length !== 0) {
      this.setState({
        cart: response.data.cart,
        isEmpty: false,
      });
    } else {
      this.setState({
        cart: [],
        isEmpty: true,
      });
    }
  };

  handleDialogOpen = (type) => {
    sessionStorage.setItem("orderId", this.generateId(16));
    if (type === "paypal") {
      this.getCurrency();
    }
    this.setState({
      dialogOpen: true,
      payType: type,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  getCurrency = async () => {
    const response = await Axios.get("https://api.exchangerate.host/latest", {
      params: {
        base: "NPR",
      },
    });
    this.setState({
      changedCurrency:
        Math.round(this.state.totalPrice * response.data.rates.USD * 100) / 100,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = (notificationStyle, message) => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        className={notificationStyle}
        autoHideDuration={1600}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          {message}
        </MuiAlert>
      </SnackBar>
    );
  };

  deleteFromCart = async (bookId) => {
    this.setState({ loading: true });
    const response = await Axios.delete(`${url}/api/carts/${bookId}`, {
      headers: {
        "x-auth-token": this.props.userToken,
      },
    });
    if (response.data.success) {
      this.setState({ loading: false });
      this.setState({ success: response.data.success });
      this.getCartCount();
      this.getData();
      this.handleNotificationOpen();
    }
  };

  generateId = (length) => {
    let arr = new Uint8Array((length || 40) / 2);
    window.crypto.getRandomValues(arr);
    return Array.from(arr, this.dec2Hex).join("");
  };

  getCartCount = async () => {
    const response = await Axios.get(`${url}/api/carts/cartDetails`, {
      headers: {
        "x-auth-token": this.props.userToken,
      },
    });
    this.setState({
      cartCount: response.data.cart.length,
    });
  };

  clearCart = async () => {
    let response = await Axios.post(`${url}/api/carts/clearCart`, null, {
      headers: {
        "x-auth-token": this.props.userToken,
      },
    });
    if (response.data.success) {
      this.getData();
      this.getCartCount();
      this.setState({
        isEmpty: true,
      });
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Header cartCount={this.state.cartCount} />
        {this.state.cart.length !== 0 ? (
          <div>
            <div className={classes.sectionDesktop}>
              <div style={{ padding: 20 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    fontWeight: "bold",
                    fontSize: 25,
                  }}
                >
                  <div> MY CART</div>
                  {this.state.loading && <FormLoader />}
                </div>
                <Divider />
              </div>
              <div style={{ paddingTop: 20, paddingBottom: 20 }}>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    variant="outlined"
                    className={classes.buttonStyle}
                    onClick={() => this.props.history.push("/books")}
                  >
                    Continue Shopping
                  </Button>
                  <Button
                    variant="outlined"
                    className={classes.buttonStyle}
                    onClick={this.clearCart}
                  >
                    Clear Cart
                  </Button>
                </div>
                <CartTable
                  column={this.state.column}
                  cart={this.state.cart}
                  deleteFromCart={this.deleteFromCart}
                />

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div style={{ padding: 10, fontSize: 35 }}>
                    Total Cost: Nrs. {this.state.totalPrice}
                  </div>
                  {this.props.isAuth === true &&
                  this.state.emailVerified === true ? (
                    <div>
                      <p style={{ fontSize: 24 }}>Pay with</p>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <CustomerKhaltiPay
                          classes={classes.buttonStyle}
                          payType="khalti"
                          productIdentity={this.state.orderId}
                          productName={`Cart-${this.state.orderId}`}
                          // productUrl={`http://localhost:3000/books`}
                          productUrl={`https://bookashram.netlify.app/books`}
                          itemDetails={this.state.cart}
                          total={this.state.totalPrice}
                          userToken={this.props.userToken}
                          reloadUrl={`/cart`}
                          clearCart={this.clearCart}
                        />
                        <Button
                          className={classes.buttonStyle}
                          onClick={() => this.handleDialogOpen("paypal")}
                        >
                          <img
                            src={PaypalLogo}
                            alt="paypal"
                            style={{ width: 150, height: 70 }}
                          />
                        </Button>
                      </div>
                      <CartDialogBox
                        open={this.state.dialogOpen}
                        payType={this.state.payType}
                        handleClose={this.handleDialogClose}
                        book={this.state.cart}
                        totalPrice={this.state.totalPrice}
                        changedCurrency={this.state.changedCurrency}
                        clearCart={this.clearCart}
                      />
                    </div>
                  ) : (
                    <div>
                      You need to first verify your email address in order to
                      complete transaction.
                    </div>
                  )}
                </div>
                {/* {this.state.transactionSuccess && this.showNotification(classes.notificationStyle, "Successfull")} */}
                {this.showNotification(
                  classes.notificationStyle,
                  "Successfully deleted"
                )}
              </div>
            </div>
            <div className={classes.sectionMobile}>
              <MobileCart
                loading={this.state.loading}
                cart={this.state.cart}
                clearCart={this.clearCart}
                deleteFromCart={this.deleteFromCart}
                totalPrice={this.state.totalPrice}
                emailVerified={this.state.emailVerified}
                payType={this.state.payType}
                orderId={this.state.orderId}
                handleDialogOpen={this.handleDialogOpen}
                handleDialogClose={this.handleDialogClose}
              />
            </div>
          </div>
        ) : this.state.isEmpty === true ? (
          <CustomEmptyMessage
            button={true}
            buttonLabel="Start Shopping"
            buttonUrl={() => this.props.history.push("/books")}
            imageIcon={
              <AddShoppingCartIcon
                style={{ width: 250, height: 250, color: "green" }}
              />
            }
            message="There is no any items in your cart"
          />
        ) : (
          <CustomLoader />
        )}
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userToken: state.UserReducer.token,
    isAuth: state.UserReducer.isAuth,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(Cart)));
